export class GiftCard {
  giftCardNumber: string;
  amount: number;
  timestamp: string;
  receiptCode: string;
  invoiceCode: string;
  invoiceNumber: string;
  creditNoteCode: string;
  creditNoteNumber: string;
  groupingNo: Array<string>;
  returnGroupingNo: Array<string>;
  constructor() {
    this.amount = 0;
    this.giftCardNumber = "";
    this.groupingNo = [];
    this.receiptCode = "";
    this.timestamp = "";
    this.invoiceCode = "";
    this.invoiceNumber = "";
    this.creditNoteCode = "";
    this.creditNoteNumber = "";
    this.returnGroupingNo = [];
  }
}
